import React from 'react'
import Popover from 'react-tiny-popover'

import CalendarDateCellPopover from './CalendarDateCellPopover'
import labels from '../../../configuration/labels'

import moment from 'moment'
import _ from 'lodash'

const CalendarDateCell = ({ currentDate, day, handleEventsPopup, renderCellEvents, renderPopoverEvents, selectedDate }) => {
  const cloneDay = day

  let formattedDate = moment(day).format('D')

  if (process.env.REACT_APP_FORMAT_CALENDER_CELL_DATE) {
    formattedDate = moment(day).format(process.env.REACT_APP_FORMAT_CALENDER_CELL_DATE)
  }

  let maxCellEvents = 3

  if (process.env.REACT_APP_COMPONENT_CALENDAR_CELL_MAX_EVENTS) {
    maxCellEvents = Number(process.env.REACT_APP_COMPONENT_CALENDAR_CELL_MAX_EVENTS)
  }

  return (
    <div
      key={day}
      className={`u-calendar__date-cell ${
        !moment(day).isSame(currentDate, 'month')
          ? 'disabled'
          : moment(day).isSame(selectedDate, 'day') && !_.isEmpty(renderCellEvents)
          ? 'selected inc-events'
          : !_.isEmpty(renderCellEvents)
            ? 'inc-events'
            : ''
      }`}
    >
      <span className="u-calendar__date-cell-number">{formattedDate}</span>

      {renderCellEvents &&
      !_.isEmpty(renderCellEvents) &&
      moment(day).isSame(currentDate, 'month') && (
        <div className="u-calendar__date-events">
          <div className="u-calendar__date-events-entries">{renderCellEvents.slice(0, maxCellEvents)}</div>

          <Popover
            isOpen={moment(day).isSame(selectedDate, 'day')}
            position={['top']}
            padding={10}
            onClickOutside={() => handleEventsPopup('false')}
            content={() => (
              <CalendarDateCellPopover
                day={day}
                handleEventsPopup={handleEventsPopup}
                renderPopoverEvents={renderPopoverEvents}
                selectedDate={selectedDate}
              />
            )}
          >
            <button
              className="btn btn-text u-calendar__date-event-toggle"
              onClick={
                moment(day).isSame(selectedDate, 'day')
                  ? () => handleEventsPopup('')
                  : () => handleEventsPopup(cloneDay)
              }
            >
              {labels.viewAllEventsCta} { renderCellEvents.length > 3 && '(' + renderCellEvents.length.toString() + ')'}
            </button>
          </Popover>
        </div>
      )}
    </div>
  )
}

export default CalendarDateCell
